"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["SetTheme"] = "set_theme";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
;
